import Vue from 'vue'
import App from '@/App.vue'
import vuetify from '@/plugins/vuetify'
import store from '@/store'
import router from '@/router'

import authorization from './plugins/auth'
import api from './plugins/api'
import eds from './plugins/eds'
import esign from './plugins/esign'
import AfterEach from './plugins/after-each'


import notify from '@ananasbear/notify'
import validate from '@ananasbear/validation'
import i18n from '@/plugins/vue-i18n'
import Table from '@/components/layauts/Table'
import TableConstructorButton from '@/components/table/TableConstructorButton.vue'
import StatusChip from '@/components/StatusChip'
import Vuelidate from 'vuelidate'
import VueTheMask from 'vue-the-mask'
import moment from 'moment-timezone'
import VueSwal from 'vue-swal'
import VueGraph from 'vue-graph'
import lodash from 'lodash'
import VueQrcodeReader from "vue-qrcode-reader"

import ExplanationDialog from '@/components/ExplanationDialog'

Vue.use(VueGraph)
Vue.component('Table', Table)
Vue.component('TableConstructorButton', TableConstructorButton)
Vue.component('StatusChip', StatusChip)
Vue.component('ExplanationDialog', ExplanationDialog)
Vue.use(Vuelidate)
Vue.use(VueTheMask)
Vue.use(VueSwal)
Vue.use(AfterEach)
Vue.use(VueQrcodeReader);

// Styles
import '@/assets/sass/index.sass'
import '@/assets/sass/measurements/measurements.sass'
import '@/assets/sass/template/template.sass'

Vue.config.productionTip = false
Vue.prototype.$eds = eds
Vue.prototype.$esign = esign
Vue.prototype.$notification = notify
Vue.prototype.$api = api
Vue.prototype.$auth = authorization
Vue.prototype.$valid = validate
Vue.prototype.$moment = moment
Vue.prototype.$lodash = lodash

Vue.mixin({
  methods: {
    $isEval: param => eval('this.'+param)
  }
})

new Vue({
  store,
  router,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
